import React from "react";
import { BreakpointConsumer } from "../../../utils/Breakpoints";
import { joinClasses } from "../../../utils/Filters";
import { getOrientation } from "../../../utils/Orientation";
export var Orientation;
(function (Orientation) {
    Orientation["HORIZONTAL"] = "horizontal";
    Orientation["VERTICAL"] = "vertical";
})(Orientation || (Orientation = {}));
export var Alignment;
(function (Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
    Alignment["CENTER"] = "center";
    Alignment["SPACE_AROUND"] = "space-around";
    Alignment["SPACE_BETWEEN"] = "space-between";
})(Alignment || (Alignment = {}));
/**
 *
 * @param or
 */
export var getOrientClass = function (or) {
    return !!or ? "scl-m-button-wrapper--orientation-".concat(or) : undefined;
};
export var getAlignmentClass = function (alignment) {
    return !!alignment ? "scl-m-button-wrapper--alignment-".concat(alignment) : undefined;
};
/**
 *
 * @param props
 */
export var ButtonsWrapper = function (props) { return (React.createElement(BreakpointConsumer, null, function (value) {
    var _a, _b;
    return (React.createElement("div", { className: joinClasses("scl-m-button-wrapper", props.asGroup ? "scl-m-button-wrapper--as-group" : undefined, getOrientClass((_b = (_a = getOrientation(value, props.orientations)) !== null && _a !== void 0 ? _a : props.defaultOrientation) !== null && _b !== void 0 ? _b : Orientation.VERTICAL), getAlignmentClass(props.alignment || Alignment.CENTER)) }, props.children));
})); };
